export default __webpack_public_path__ + "static/media/service-01.a08102f0.jpg";